/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * API
 * Audius V1 API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { TrackActivity } from './TrackActivity';
import {
    TrackActivityFromJSON,
    TrackActivityFromJSONTyped,
    TrackActivityToJSON,
} from './TrackActivity';

/**
 * 
 * @export
 * @interface HistoryResponse
 */
export interface HistoryResponse {
    /**
     * 
     * @type {Array<TrackActivity>}
     * @memberof HistoryResponse
     */
    data?: Array<TrackActivity>;
}

/**
 * Check if a given object implements the HistoryResponse interface.
 */
export function instanceOfHistoryResponse(value: object): value is HistoryResponse {
    let isInstance = true;

    return isInstance;
}

export function HistoryResponseFromJSON(json: any): HistoryResponse {
    return HistoryResponseFromJSONTyped(json, false);
}

export function HistoryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): HistoryResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(TrackActivityFromJSON)),
    };
}

export function HistoryResponseToJSON(value?: HistoryResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(TrackActivityToJSON)),
    };
}

